<template>
    <m-table ref="table" :refresh="refreshData" :args="args" @click="(row, index) => this.$emit('click', row, index)"
             :initial="initial" :rowBind="rowBind">
        <template slot="header">
            <slot name="header"></slot>
        </template>
        <template v-slot="{row, index}">
            <slot :row="row" :index="index"></slot>
        </template>
    </m-table>
</template>
<script>
import Ajax from '@/js/ajax.js'

export default {
    props: {
        rowBind: Function,
        url: String,
        args: {
            type: Object,
            default: () => ({})
        },
        filter: Function,
        interceptor: Function,
        initial: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        refresh() {
            this.$refs.table.refreshData()
        },
        refreshData(page, rows, args) {
            return Ajax.post(this.url, {
                page: page,
                rowsPerPage: rows,
                ...args
            }, false).then(resp => {
                // Intercept the whole response
                // Sometimes response is not pagenation response
                resp = this.interceptor ? this.interceptor(resp) : resp
                var data = {
                    count: resp.total,
                    data: this.filter ? this.filter(resp.items) : resp.items
                }
                return data
            })
        }
    }
};
</script>
